import { useReducer } from 'react';

const getInitialParams = (): Params => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const storeId = userData?.userDetails?.storeId || undefined;
  const merchantId = userData?.userId || undefined;
  // const merchantId = undefined;

  return {
    sortBy: undefined,
    sortDirection: 'desc',
    page: 1,
    limit: 10,
    search: undefined,
    storeId,
    status: undefined,
    type: '',
    merchantId,
  };
};

type Params = {
  sortBy: string | undefined;
  sortDirection: 'asc' | 'desc';
  page: number;
  limit: number;
  search?: string;
  storeId: string;
  status: string | undefined;
  type: string | undefined;
  merchantId: string |undefined;
};

type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'SET_TYPE'; payload: string | undefined }
  | { type: 'RESET' };

function reducer(state: Params, action: Action): Params {
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload, page: 1 };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload, page: 1 };
    case 'SET_TYPE':
      return { ...state, type: action.payload, page: 1 };
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortDirection: action.payload.sortOrder,
        page: 1,
      };
    case 'RESET':
      return getInitialParams();
    default:
      return state;
  }
}

export function useReviewManagementParams() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());

 

  return { params, dispatch };
}
